import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const API_URI = "https://pixabay.com/api/";
const API_KEY = "4319491-ba9467d0c8bc927367b7ea109";
const url = `${API_URI}?key=${API_KEY}`;

const loadCollections = () => {
  try {
    const coll = localStorage.getItem("collections");
    if (coll === null) {
      return undefined;
    }
    return JSON.parse(coll);
  } catch (err) {
    return undefined;
  }
};

const saveCollections = state => {
  try {
    const coll = JSON.stringify(state);
    localStorage.setItem("collections", coll);
  } catch (err) {
    console.log(err);
  }
};

export default new Vuex.Store({
  state: {
    search_imgs: [],
    fetch_imgs: [],
    collections: loadCollections() || []
  },
  getters: {
    search_imgs: state => state.search_imgs,
    fetch_imgs: state => state.fetch_imgs,
    collections: state => state.collections
  },
  mutations: {
    search_imgs(state, payload) {
      state.search_imgs = payload;
    },
    fetch_imgs(state, payload) {
      state.fetch_imgs = payload;
    },
    add_collections(state, payload) {
      state.collections = [...state.collections, payload];
      saveCollections(state.collections);
    },
    delete_collections(state, payload) {
      state.collections.map((t, i) => {
        if (payload.id === t.id) {
          state.collections = [
            ...state.collections.slice(0, i),
            ...state.collections.slice(i + 1)
          ];
        }
      });
      saveCollections(state.collections);
    },
    remove_all(state) {
      state.collections = "";
      localStorage.removeItem("collections");
    }
  },
  actions: {
    fetchImages(context) {
      axios
        .get(url + "&q='nature'&per_page=20")
        .then(r => {
          console.log(r)
          context.commit("fetch_imgs", r.data.hits);
        })
        .catch(err => {
          console.log("err");
        });
    },
    SearchImages(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${url}&q=${payload}&per_page=20`)
          .then(r => {
            context.commit("search_imgs", r.data.hits);
            resolve({ loading: false });
          })
          .catch(err => console.log(err));
      });
    },
    addCollections(context, payload) {
      context.commit("add_collections", payload);
    },
    deleteCollections(context, payload) {
      context.commit("delete_collections", payload);
    }
  }
});
